import React from "react";
import TimelineStores from "./pages-components/about-us-components/timeline-stores";
function Timeline() {
    return (
        <>
            <br />
            <br />
            <br />
            <br/>
            {/* <!-- page-title --> */}
            <div class="tf-page-title style-2">
                <div class="container-full">
                    <div class="heading text-center">Timeline</div>
                </div>
            </div>
            {/* <!-- /page-title --> */}
            <TimelineStores/>


            <br />
            <br />
        </>
    )
}
export default Timeline;